import { Col } from 'antd';
import styled from 'styled-components';

export const ReverseCol = styled(Col)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;
